'use client';

import React, { useState, useRef, useEffect } from 'react';
import { FaSignOutAlt } from 'react-icons/fa';
import toast, { Toaster } from 'react-hot-toast';
import SiteLogo from '../assets/images/SparkLogistics.jpg';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [userName, setUserName] = useState('');
  const dropdownRef = useRef(null);

  // Load stored username
  useEffect(() => {
    const storedUserName = localStorage.getItem('userName');
    if (storedUserName) {
      setUserName(storedUserName);
    }
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    setShowConfirmModal(true);
    setMenuOpen(false);
  };

  const confirmLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    toast.success('Logged out successfully', {
      style: { background: '#10b981', color: '#fff' },
    });
    setTimeout(() => {
      window.location.href = '/';
    }, 1000);
  };

  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />

      {/* Header */}
      <header
        className="fixed top-0 left-0 w-full h-[65px] bg-white text-slate-800 shadow-sm border-b border-gray-200 z-50"
      >
        <div className="h-full px-4 sm:px-6 flex items-center justify-between">

          {/* Logo + Title */}
          <a href="/Dashboard" className="flex items-center gap-3 group">
            <img
              src={SiteLogo}
              alt="Logo"
              className="h-10 w-auto object-contain rounded-lg shadow-md ring-1 ring-blue-500 group-hover:ring-blue-400 group-hover:shadow-lg transition-all duration-300"
              style={{ mixBlendMode: 'multiply' }}
            />
            <div className="hidden sm:block">
              <div className="text-xl font-bold text-blue-900">
                Spark Logistics
              </div>
              <div className="text-xs text-blue-600 tracking-wider font-semibold">Logistics Dashboard</div>
            </div>
          </a>

          {/* Profile Section */}
          <div className="relative" ref={dropdownRef}>
            <button
              onClick={() => setMenuOpen((prev) => !prev)}
              className="flex items-center gap-3 p-2 rounded-full hover:bg-slate-50 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-100"
            >
              <span className="hidden sm:block text-sm font-medium text-slate-700">
                {userName || 'User'}
              </span>
              <div className="relative">
                <img
                  className="h-10 w-10 rounded-full border-2 border-blue-500 object-cover shadow-md"
                  src="https://cdn-icons-png.freepik.com/512/219/219988.png"
                  alt="User"
                />
                <span className="absolute bottom-0 right-0 h-3 w-3 bg-green-400 border-2 border-slate-900 rounded-full ring-1 ring-blue-500"></span>
              </div>
            </button>

            {menuOpen && (
              <div className="absolute right-0 mt-2 w-56 bg-white text-slate-800 rounded-xl shadow-xl border border-gray-100 py-2 z-50 overflow-hidden">
                <div className="px-4 py-3 border-b border-gray-100">
                  <p className="text-sm font-semibold text-slate-800 truncate">
                    {userName || 'User'}
                  </p>
                  {/* <p className="text-xs text-slate-500">
                    {localStorage.getItem('userRole') || 'Admin'}
                  </p> */}
                </div>
                <button
                  onClick={handleLogout}
                  className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-red-600 hover:bg-red-50 transition-all duration-200"
                >
                  <FaSignOutAlt className="text-lg" />
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </header>

      {/* Logout Confirmation Modal */}
      {showConfirmModal && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-slate-800 rounded-xl shadow-2xl p-6 w-full max-w-sm border border-blue-700/50">
            <h3 className="text-lg font-bold text-blue-300 mb-2">
              Confirm Logout
            </h3>
            <p className="text-sm text-gray-300 mb-6">
              Are you sure you want to end your session?
            </p>
            <div className="flex justify-end gap-3">
              <button
                onClick={() => setShowConfirmModal(false)}
                className="px-4 py-2 text-sm font-medium text-gray-300 bg-slate-700 rounded-lg hover:bg-slate-600 transition"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  setShowConfirmModal(false);
                  confirmLogout();
                }}
                className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition shadow-sm ring-1 ring-red-500"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;